import { Button, Card, CardContent, CardHeader, Stack, Typography } from '@mui/material'
import { HatchCoverMoveStore } from '@operations/stores/HatchCoverMoveStore'
import { useTranslate } from '@tolgee/react'
import { DashboardTile, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

interface Props {
  store: HatchCoverMoveStore
  visitId: number
  onViewClick: (e: any) => void
}

export const HatchCoverSummary = observer(({ store, visitId, onViewClick }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([store.loadRecordsByVisitId(visitId)])
    }

    fetchData()
  }, [store, visitId])

  const { totalOpened, totalClosed } = store

  return (
    <Card sx={{ width: '100%', height: '100%' }}>
      <CardHeader
        action={
          <Button color='inherit' onClick={onViewClick} data-cy='hatch-cover-total-view-btn'>
            {t('view', 'View')}
          </Button>
        }
        title={<Typography variant='h2'>{t('hatchCovers', 'Hatch covers ')}</Typography>}
      />
      <CardContent sx={{ minHeight: '100%' }}>
        <Stack direction='row' gap={theme.customSpacing.xxl}>
          <DashboardTile
            label={t('opened', 'Opened')}
            value={totalOpened}
            valueDataCy='hatch-cover-total-opened'
          />
          <DashboardTile
            label={t('closed', 'Closed')}
            value={totalClosed}
            valueDataCy='hatch-cover-total-closed'
          />
        </Stack>
      </CardContent>
    </Card>
  )
})
